import { z } from 'zod'
import { oc } from '@orpc/contract'
import { REFERRAL_SPECIALTY_CODES } from '../referral-specialties.schema'
import { frequentRecipientSchema, latSchema, lonSchema } from './referral-discovery-views.schema'

export const referralDiscoveryFrequentInputSchema = z
  .object({
    specialtyCode: z.enum(REFERRAL_SPECIALTY_CODES),
    lat: latSchema.optional(),
    lon: lonSchema.optional(),
  })
  .refine((v) => (v.lat === undefined) === (v.lon === undefined), {
    message: 'lat and lon must be given together',
  })

export const referralDiscoveryFrequent = oc
  .route({ method: 'GET', path: '/v2/referral-discovery/frequent' })
  .input(referralDiscoveryFrequentInputSchema)
  .output(z.object({ recipients: z.array(frequentRecipientSchema) }))
